module.exports = __webpack_public_path__ + "static/media/copy-icon.4db180ef.svg";